export default "__VITE_ASSET__C3Z2Jm_Z__"